import { Controller } from "@hotwired/stimulus"
import { phoneDigits } from "../lib/phone_digits"
import { syncGateReason } from "../lib/gate_reason"

// Ready Gate (DESIGN.md PATTERN-3) for the Spam Protector "Add Your First
// Number" card: Start Protecting This Number stays disabled until the phone is
// a 10-digit US number and the nickname is filled — the same checks
// SpamProtector::Number validates — and the footer line names what's left
// ("2 left: Phone Number · Name"). The server still re-validates.
const US_PHONE_DIGITS = 10

export default class extends Controller {
  static targets = ["phone", "nickname", "submit", "hint"]

  connect() {
    this.sync()
  }

  sync() {
    const left = this.missing()
    const reason = left.length ? `${left.length} left: ${left.join(" · ")}` : ""
    if (this.hasHintTarget) this.hintTarget.textContent = reason
    syncGateReason(this.submitTarget, { ready: left.length === 0, reason })
  }

  missing() {
    const left = []
    if (phoneDigits(this.phoneTarget.value).length !== US_PHONE_DIGITS) left.push("Phone Number")
    if (!this.nicknameTarget.value.trim()) left.push("Name")
    return left
  }
}
